import { TextField, MenuItem } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import {
  useListarPeriodosFacturacionQuery,
  backendToUrlFecha,
  urlToBackendFecha,
} from "src/services/facturasApi";

const MESES = [
  "enero",
  "febrero",
  "marzo",
  "abril",
  "mayo",
  "junio",
  "julio",
  "agosto",
  "septiembre",
  "octubre",
  "noviembre",
  "diciembre",
];

// "2026/05" -> "Mayo 2026"
function etiquetaPeriodo(fechaBackend) {
  const [anio, mes] = fechaBackend.split("/");
  const nombre = MESES[Number(mes) - 1] ?? mes;
  return `${nombre.charAt(0).toUpperCase()}${nombre.slice(1)} ${anio}`;
}

export default function SelectorPeriodo({ sucursal, fechaActual }) {
  const navigate = useNavigate();
  const { data } = useListarPeriodosFacturacionQuery(sucursal, {
    skip: !sucursal,
  });
  const periodos = data?.periodos ?? [];

  // El value debe estar en el mismo formato que los MenuItem (YYYY/MM del backend);
  // la URL trae YYYY-MM, se normaliza para que el select calce con una opcion real.
  const valor = fechaActual ? urlToBackendFecha(fechaActual) : "__VIGENTE__";

  const onChange = (e) => {
    const v = e.target.value;
    if (v === "__VIGENTE__") navigate("/dashboard/facturacion-planes");
    else navigate(`/dashboard/facturacion-planes/${backendToUrlFecha(v)}`);
  };

  return (
    <TextField
      select
      size="small"
      label="Periodo"
      value={valor}
      onChange={onChange}
      sx={{ minWidth: 180 }}
    >
      <MenuItem value="__VIGENTE__">Periodo vigente</MenuItem>
      {periodos.map((p) => (
        <MenuItem key={p.fecha} value={p.fecha}>
          {etiquetaPeriodo(p.fecha)}
        </MenuItem>
      ))}
    </TextField>
  );
}
